import { UmbracoTypes } from '~/lib/data-contract';
import { useBrandResults } from '~/services/loop54/hooks';
import { memo } from 'react';
import { CarouselWithItems } from './helpers';

function M30BrandProductCarousel({
    headline,
    brand,
    link,
    onlyShowInStock,
}: Omit<UmbracoTypes.IM30BrandProductCarouselModule, 'type'>) {
    const { data } = useBrandResults({ brand, onlyShowInStock });

    return <CarouselWithItems data={data?.results?.items} headline={headline} link={link} />;
}

export default memo(M30BrandProductCarousel);
